module.exports = __webpack_public_path__ + "img/fastinitiate.7f51775a.png";